import Banner from './Banner';
import Problem from './Problem';
import Solution from './Solution';
import Results from './Results';
import Companies from './Companies';
import Webinar from './Webinar';

export { Banner, Problem, Solution, Results, Companies, Webinar };
